export const WORK_ORDER_CATEGORIES = {
    CATEGORY_PRIMARY: 'primary',
    CATEGORY_SECONDARY: 'secondary',
    CATEGORY_STUDENT: 'student'
};

// Planner choices for the automatic batch name (BALTT-530); mirror WorkOrder.BATCH_* constants in the backend.
export const BATCH_BEST_BEFORE_MONTH_OPTIONS = [3, 6, 7, 8, 9, 10, 11, 12, 14, 15, 18, 24];
export const BATCH_FORMAT_TYPES = ['EU', 'US'];
